import {defineStore} from 'pinia'
import Roles from "~/utils/roles"
import type {OutputSession} from "~/models"

export const useSessionsStore = defineStore('sessions', {
    state: () => ({
        sessions: [] as OutputSession[],
    }),
    actions: {
        async load() {
            const {user} = useAuth()

            if (user.value?.role === Roles.VIEWER.value) {
                return
            }

            this.sessions = await useApi().getSessions()
        },
    },
})